import { defaultCollisionDetection, directionBiased } from "@dnd-kit/collision";
import type { CollisionDetector } from "@dnd-kit/collision";

/** A group is tall enough to overlap several rows at once, so targeting it by
 * overlap sets the list chasing itself: each rearrangement changes which row it
 * overlaps most and provokes the next. Direction breaks that loop. */
export const aimedAtByTravelWhenAGroup: CollisionDetector = (input) =>
  input.dragOperation.source?.type === "group"
    ? directionBiased(input)
    : defaultCollisionDetection(input);
